import config from '../../common/config';
import { createNumberedMarkerOverlay } from '../../common/numberedMarkerOverlay';

const state = {
  // center: { lat: 45.508, lng: -73.587 },
  // markers: [],
  // placesToSet: [],
  // currentPlace: null,
  // appMap: null,
};
const getters = {
  // center: state => state.center,
  // markers: state => state.markers,
  // placesToSet: state => state.placesToSet,
  // currentPlace: state => state.currentPlace,
  // appMap: state => state.appMap,
};
const actions = {
  addMarkerByLatAndLng: ( _, mapAndPoint) => {
    if( ! mapAndPoint.map ){ return; }
    if( ! mapAndPoint.point.latPoint ){ return; }
    var markLockation = new google.maps.LatLng(
      parseFloat( mapAndPoint.point.latPoint),
      parseFloat( mapAndPoint.point.lngPoint));  
    var name = '';
    if( 'name' in mapAndPoint.point ){
      name = mapAndPoint.point.name
    }

    // HTML/CSS numbered marker (1-99) - no Canvas
    if( 'numberedMarker' in mapAndPoint.point ){
      var nm = mapAndPoint.point.numberedMarker;
      var overlay = createNumberedMarkerOverlay(
        markLockation,
        mapAndPoint.map,
        nm.baseCircleUrl,
        nm.number,
        name
      );
      mapAndPoint.rideMarkers.push( overlay );
      return;
    }

    // Regular image marker
    var iconUrl = config.config.MAP_POINT_WITH_COLLOR[0].IMAGE_URL;
    if( 'iconUrl' in mapAndPoint.point ){
      iconUrl = mapAndPoint.point.iconUrl;
    }
    var myImage = {
      url: iconUrl,
      size: new google.maps.Size(33, 33),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(15, 40),
    };

    var isDraggable = false;
    if( 'draggable' in mapAndPoint.point ){
      isDraggable = mapAndPoint.point.draggable;
    }

    var marker = new google.maps.Marker({
      position: markLockation,
      map: mapAndPoint.map,
      draggable: isDraggable,
      icon: myImage,
    })
    if(name){
      var infoWindow = new google.maps.InfoWindow({
        content: name,
      });
      
      marker.addListener('click', function(event) {
        if (event && event.domEvent && event.domEvent.stopPropagation) {
          event.domEvent.stopPropagation();
        }
        infoWindow.open(mapAndPoint.map, marker);
      });
    }
    if( mapAndPoint.point.bounce ){
      if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
         }
         marker.setAnimation( mapAndPoint.point.bounce );
    }
    
    if( 'onDragEnd' in mapAndPoint.point && mapAndPoint.point.onDragEnd ){
      marker.addListener('dragend', function(event) {
        var newLat = event.latLng.lat();
        var newLng = event.latLng.lng();
        mapAndPoint.point.onDragEnd(newLat, newLng);
      });
    }

    mapAndPoint.rideMarkers.push( marker );
  },
  removeAllMarkers: ( _, markers) =>{
    while (markers.length > 0) {
      markers.pop().setMap(null);
    } 
  },

  fitBoundesToMarkers: ( _, mapContainer) => {
    if(!mapContainer.appMap){
      return;
    }
    if(mapContainer.markers.length == 0){
      return;
    }
    var bounds = new google.maps.LatLngBounds();
    var i;
    for( i=0; i < mapContainer.markers.length; i++ ){
      bounds.extend(mapContainer.markers[i].getPosition());
    }
    if (mapContainer.markers.length > 1) {
      mapContainer.appMap.fitBounds(bounds);
    }
    else if (mapContainer.markers.length == 1) {
      mapContainer.appMap.setCenter(bounds.getCenter());
      const mapZoomLevel = mapContainer.zoomLevel ? mapContainer.zoomLevel : 12;
      mapContainer.appMap.setZoom(mapZoomLevel);
    }
  },
}
const mutations = {
  // setCurrentPlace( state, place ) {
  //   state.currentPlace = place;
  // },
  // setAppMap( state, appMap ) {
  //   state.appMap = appMap;
  // },
  // addMarker( state, marker ) {
  //   state.markers.push( marker );
  // },
  // addPlace( state, place ) {
  //   state.placesToSet.push( { place } );
  // },
  // setCenter( state, center ) {
  //   state.center =  center;
  // },
};

export default {
  state,
  getters,
  actions,
  mutations
};
